import React from 'react';
import { Outlet, useSearchParams } from "react-router-dom";
import { ExeDialog } from './ExeDialog';
import { isCouponMode } from './couponMode';

// Import dei componenti step
import { CodBolla } from './steps/CodBolla';
import { RagSoc } from './steps/RagSoc';
import { Targa } from './steps/Targa';
import { RagSocVettore } from './steps/RagSocVettore';
import { RagSocConducente } from './steps/RagSocConducente';
import { CodCommessa } from './steps/CodCommessa';
import { Destinazione } from './steps/Destinazione';
import { DestinazionePattern } from './steps/DestinazionePattern';
import { Pesi } from './steps/Pesi';
import { NumSilos } from './steps/NumSilos';
import { Temperatura } from './steps/Temperatura';
import { Cig } from './steps/Cig';
import { Stampante } from './steps/Stampante';
import { Conferma } from './steps/Conferma';

/*
Wizard DDT 2026 - Raccolta dati DDT usando verifica_valori_ddt_e_salva
Ogni step è un componente che riceve:
- currURLSearchParams: parametri URL correnti
- onFinish: callback per avanzare al passo successivo
- verificaData: risposta da verifica_valori_ddt_e_salva con opzioni e suggerimenti
*/

// Lista ordinata dei componenti del wizard
const COMPONENT_LIST = [
    CodBolla,
    RagSoc,
    Targa,
    RagSocVettore,
    RagSocConducente,
    CodCommessa,
    Destinazione,
    DestinazionePattern,
    Pesi,
    NumSilos,
    Temperatura,
    Cig,
    Stampante,
    Conferma
];

export const route = {
    path: '/ddt2026',
    element: <DDT2026Add />,
    children: [
        {
            path: '',
            element: <ExeDialog reactComponentList={COMPONENT_LIST} />,
        },
    ]
};

function DDT2026Add() {
    const [searchParams] = useSearchParams();
    const codBolla = searchParams.get('cod_bolla');
    // Il titolo segue la scelta fatta nella pagina del codice bolla
    const titolo = isCouponMode(searchParams)
        ? 'Coupon di carico'
        : 'Documento di trasporto o consegna';
    return (
        <div className="card shadow m-3">
            <div className="card-header">
                <h1 className="mb-0">{titolo}{codBolla ? ` ${codBolla}` : ''}</h1>
            </div>
            <Outlet />
        </div>
    );
}

export default DDT2026Add;
